import { logger } from '../utils/logger';

const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;
const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;
const AUTH0_CALLBACK_URL = process.env.REACT_APP_AUTH0_CALLBACK_URL;
const IS_LOCALSTACK = process.env.REACT_APP_USE_LOCALSTACK === 'true';

const Auth0ProviderWrapper = ({ children }) => {
  // Skip Auth0 only if LocalStack is enabled AND no Auth0 config is present
  // This allows "Hybrid Mode" (Real Auth0 + LocalStack Backend)
  if (IS_LOCALSTACK && !AUTH0_DOMAIN) {
    logger.debug('Skipping Auth0 for LocalStack development mode (No Auth0 config found)');
    return children;
  }

  // Try to load Auth0Provider
  try {
    const { Auth0Provider } = require('@auth0/auth0-react');

    if (!AUTH0_DOMAIN || !AUTH0_CLIENT_ID) {
      logger.error('Auth0 configuration missing');
      return <div>Auth0 configuration error</div>;
    }

    const providerConfig = {
      domain: AUTH0_DOMAIN,
      clientId: AUTH0_CLIENT_ID,
      authorizationParams: {
        redirect_uri: AUTH0_CALLBACK_URL || window.location.origin,
        audience: AUTH0_AUDIENCE,
        scope: 'openid profile email read:matches write:matches write:bread',
      },
      cacheLocation: 'localstorage',
      onRedirectCallback: (appState) => {
        // Redirect to the page the user was on before login, or home page
        const targetUrl = appState?.returnTo || '/';
        window.history.replaceState({}, document.title, targetUrl);
        logger.debug('Auth0 callback completed, redirecting to:', targetUrl);
      },
    };

    logger.debug('Initializing Auth0 with domain:', AUTH0_DOMAIN);

    return <Auth0Provider {...providerConfig}>{children}</Auth0Provider>;
  } catch (error) {
    logger.error('Auth0 package not available:', error);
    logger.debug('Falling back to no-auth mode');
    return children;
  }
};

export default Auth0ProviderWrapper;
